import axios from 'axios';

export async function getSystemLogExport(
  category: number,
  fromTime: string,
  toTime: string
): Promise<Blob> {
  const url = `/api/system-logs/${
    category && category !== -1 ? category : 0
  }/export/${fromTime}/${toTime}`;
  try {
    const { data } = await axios.get(url, { responseType: 'blob' });
    return data as Blob;
  } catch (err) {
    throw err;
  }
}
